import { Snackbar, Alert, AlertTitle } from '@mui/material';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';

const ToastNotification = ({
    message,
    severity = 'info',
    onClose,
    open = true,
    autoHideDuration = 5000,
    anchorOrigin = { vertical: 'top', horizontal: 'right' },
}) => {
    const getTitle = () => {
        switch (severity) {
            case 'error':
                return formatMessage(Locale.error);
            case 'success':
                return formatMessage(Locale.success);
            case 'warning':
                return formatMessage(Locale.warning);
            case 'info':
            default:
                return formatMessage(Locale.info);
        }
    };

    return (
        <Snackbar
            open={open}
            anchorOrigin={anchorOrigin}
            autoHideDuration={autoHideDuration}
            disableWindowBlurListener
            onClose={onClose}>
            <div>
                <Alert severity={severity} contrast="normal" width="toast" onClose={onClose} title={getTitle()}>
                    <AlertTitle>{getTitle()}</AlertTitle>
                    {message}
                </Alert>
            </div>
        </Snackbar>
    );
};

export default ToastNotification;
